function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.9375 6.6875C12.9375 3.37379 10.2512 0.6875 6.9375 0.6875C3.62379 0.6875 0.9375 3.37379 0.9375 6.6875C0.9375 10.0012 3.62379 12.6875 6.9375 12.6875C10.2512 12.6875 12.9375 10.0012 12.9375 6.6875Z",
  fill: "url(#paint0_radial_880_6)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.3663 6.68638C10.3663 4.79283 8.83127 3.25781 6.93772 3.25781C5.04418 3.25781 3.50916 4.79283 3.50916 6.68638C3.50916 8.57992 5.04418 10.1149 6.93772 10.1149C8.83127 10.1149 10.3663 8.57992 10.3663 6.68638Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial_880_6",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(6.9375 6.6875) rotate(90) scale(6)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.5
})));

var SvgOngoingWhite = function SvgOngoingWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOngoingWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ongoing-white.af79c904.svg";
export { ForwardRef as ReactComponent };